export const trainerData = {
    route_1_trainer_1: {
        name: 'Sebastian',
        type: 'youngster',
        preBattleText: 'Hey you! Wanna battle?',
        postBattleText: "Oh man... you're good...",
        text: "I'm only getting started. Some day we should have a rematch!",
        isDefeated: false,
        movementPattern: 'faceRandomDirection',
        party: [
            { id: 177, level: 3 }, // Natu
            { id: 263, level: 2 }, // Zigg
        ],
        reward: 500,
    },
    route_1_trainer_2: {
        name: 'Zach',
        type: 'youngster',
        preBattleText: "I've trained so much! Wanna check out my Pokemon?",
        postBattleText: "I'm gonna have to keep training!.",
        text: 'I love training my Pokemon. You should train yours too!',
        isDefeated: false,
        movementPattern: 'idle',
        party: [{ id: 69, level: 4 }],
        reward: 500,
    },
    route_1_trainer_3: {
        name: 'Alejandro',
        type: 'youngster',
        preBattleText: 'This is MY secret passage!',
        postBattleText: 'I guess you can keep this secret.',
        text: 'I thought was the only one who knew about this secret passage to Route 1.',
        isDefeated: false,
        movementPattern: 'idle',
        party: [
            { id: 194, level: 3 }, // Wooper
            { id: 263, level: 3 }, // Zigzagoon
        ],
        reward: 300,
    },
    route_1_trainer_4: {
        name: 'Natalia',
        type: 'lass',
        preBattleText: "You're gonna need the PC at Mistral Heights if you manage to beat me!",
        postBattleText: 'I guess we can go together...',
        text: "There's a PC across the bridge there where you can heal up!",
        isDefeated: false,
        movementPattern: 'faceRandomDirection',
        party: [
            { id: 114, level: 4 },
            { id: 83, level: 4 },
        ],

        reward: 1000,
    },
    route_2_trainer_1: {
        name: 'Andres',
        type: 'youngster',
        preBattleText: 'I caught a rare pokémon earlier.',
        postBattleText: 'I swear I caught it myself!',
        text: 'I love finding rare pokémon.',
        isDefeated: false,
        movementPattern: 'idle',
        party: [{ id: 213, level: 4 }],

        reward: 300,
    },
    route_2_trainer_2: {
        name: 'Ricardo',
        type: 'youngster',
        preBattleText: "Bug-type pokémon are underrated. Don't believe me?",
        postBattleText: 'You got lucky...',
        text: "Bug-type pokémon can be really strong if you train them well. That's what my Mom said...",
        isDefeated: false,
        movementPattern: 'idle',
        party: [
            { id: 266, level: 6 }, // Silcoon
            { id: 268, level: 6 }, // Cascoon
        ],

        reward: 300,
    },

    town_trainer_1: {
        name: 'Scott',
        type: 'youngster',
        preBattleText: "Hey! I see you, therefore I'll battle you!",
        postBattleText: 'That was a good battle!',
        text: 'What a good battle we had earlier!',
        isDefeated: false,
        party: [
            { id: 216, level: 8 },
            { id: 263, level: 8 },
        ],
        reward: 250,
    },
    town_trainer_2: {
        name: 'Mike',
        type: 'youngster',
        preBattleText: 'Check out my bugs!',
        postBattleText: 'Dang... I need more bugs.',
        isDefeated: false,
        party: [
            { id: 265, level: 5 },
            { id: 265, level: 5 },
            { id: 269, level: 10 },
        ],
        reward: 250,
    },
    route_1_rival: {
        name: 'Rumbi',
        type: 'rival',
        postBattleText: '... I guess I lost.',
        party: [{ id: 29, level: 5 }],
        reward: 1000,
        isDefeated: true,
        useFresh: false,
    },
    route_1_pokemon_professor: {
        name: 'Professor Abu',
        type: 'professor',
        postBattleText: '...',
        party: [{ id: 3, level: 40 }],
        reward: 0,
        isDefeated: true,
        useFresh: false,
    },
    forest_rumbi: {
        name: 'Rumbi',
        type: 'youngster',
        preBattleText: 'This forest aint big enough for the two of us!',
        postBattleText: `I guess I'll go...`,
        text: 'Sorry for what I said earlier. You are good!',
        isDefeated: false,
        party: [
            {
                id: 255,
                level: 7,
                moves: {
                    0: 'growl',
                    1: 'tackle',
                    2: 'leer',
                    3: 'water_gun',
                },
            },
        ],
    },
    forest_ginger: {
        name: 'Ginger',
        type: 'lass',
        preBattleText: 'Hey! Do you want to battle!',
        postBattleText: 'That was fun!',
        text: 'We had a great battle!',
        isDefeated: false,
        party: [
            {
                id: 258,
                level: 7,
                moves: {
                    0: 'growl',
                    1: 'tackle',
                    2: 'leer',
                    3: 'ember',
                },
            },
        ],
    },
    sandbox_trainer: {
        name: 'Trainer',
        type: 'youngster',
        preBattleText: 'Battle?',
        postBattleText: 'Thanks!',
        text: 'Good battle!',
        isDefeated: false,
        party: [
            {
                id: 1,
                level: 2,
                moves: {
                    0: 'whirlwind',
                    1: 'whirlwind',
                    2: 'whirlwind',
                    3: 'whirlwind',
                },
            },
            {
                id: 4,
                level: 2,
                moves: {
                    0: 'whirlwind',
                    1: 'whirlwind',
                    2: 'whirlwind',
                    3: 'whirlwind',
                },
            },
            // {
            //     id: 7,
            //     level: 2,
            //     moves: {
            //         0: 'growl',
            //         1: 'scratch',
            //         2: 'leer',
            //         3: 'water_gun',
            //     },
            // },
        ],
    },
};
